// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//       }

//       setActiveMedia(mediaId, smooth = false) {
//         if (!mediaId) return false;

//         let cleanMediaId = mediaId;
//         if (mediaId.indexOf('-') !== -1) {
//           const parts = mediaId.split('-');
//           cleanMediaId = parts[parts.length - 1];
//         }

//         let element = this.querySelector(`[data-media-id="${cleanMediaId}"]`);
        
//         if (!element) {
//           element = this.querySelector(`[data-media-id="${mediaId}"]`);
//         }

//         if (!element) return false;

//         this.querySelectorAll('[data-media-id].active').forEach((node) => node.classList.remove('active'));

//         element.classList.add('active');

//         const allMediaElements = Array.from(this.querySelectorAll('[data-media-id]'));
//         const mediaIndex = allMediaElements.indexOf(element);

//         this.syncSlideshow(element, mediaIndex, smooth);
//         this.syncThumbnails(element, mediaIndex);

//         if (this.classList.contains('media-gallery--grid')) {
//           this.swapGridMedia(element, mediaIndex);
//         }

//         return true;
//       }

//       /**
//        * Sync slideshow/swiper component when media is activated
//        * @param {HTMLElement} mediaElement - The active media element
//        * @param {number} mediaIndex - The index of the media in the gallery
//        * @param {boolean} smooth - Whether to use smooth transition
//        */
//       // syncSlideshow(mediaElement, mediaIndex, smooth = false) {
//       //   try {
//       //     if (!this.classList.contains('media-gallery--carousel')) return;

//       //     const swiperComponent = this.querySelector('swiper-component');
//       //     if (!swiperComponent) return;
          
//       //     const waitForSwiper = (retries = 10) => {
//       //       if (swiperComponent.initSwiper) {
//       //         const slides = Array.from(swiperComponent.querySelectorAll('.swiper-wrapper .swiper-slide'));
//       //         let slideIndex = mediaIndex;
//       //         const slideElement = mediaElement.closest('.swiper-slide');
//       //         if (slideElement) {
//       //           const foundIndex = slides.indexOf(slideElement);
//       //           if (foundIndex >= 0) {
//       //             slideIndex = foundIndex;
//       //           }
//       //         }

//       //         if (slideIndex >= 0 && slideIndex < slides.length && swiperComponent.initSwiper) {
//       //           swiperComponent.initSwiper.slideTo(slideIndex, smooth ? 800 : 0);
//       //         }
//       //       } else if (retries > 0) {
//       //         setTimeout(() => waitForSwiper(retries - 1), 50);
//       //       }
//       //     };

//       //     waitForSwiper();
//       //   } catch (e) {
//       //     try {
//       //       if (this.slideshow && typeof this.slideshow.goTo === 'function') {
//       //         this.slideshow.goTo(mediaIndex);
//       //       }
//       //     } catch (err) {
//       //       // silent
//       //     }
//       //   }
//       // }
// syncSlideshow(mediaElement, mediaIndex, smooth = false) {
//   try {
//     if (!this.classList.contains('media-gallery--carousel')) return;

//     // Mobile smooth scroll mode मध्ये असेल, तर scrollIntoView वापरा (swiper transform काम करणार नाही)
//     const isMobileSmoothScroll = 
//       this.classList.contains('media-gallery--mobile-smooth-scroll') &&
//       window.innerWidth < 750;

//     // if (isMobileSmoothScroll) {
//     //   const wrapper = this.querySelector('.swiper-wrapper');
//     //   if (wrapper && mediaElement) {
//     //     mediaElement.scrollIntoView({
//     //       behavior: smooth ? 'smooth' : 'auto',
//     //       block: 'nearest',
//     //       inline: 'start'
//     //     });
//     //   }
//     //   return;
//     // }
// if (isMobileSmoothScroll) {
//   const wrapper = this.querySelector('.swiper-wrapper');
//   if (wrapper && mediaElement) {
//     // स्क्रोल मोशन न दाखवता लगेच पोझिशन बदला
//     mediaElement.scrollIntoView({
//       behavior: 'instant',
//       block: 'nearest',
//       inline: 'start'
//     });

//     // हलकी fade इफेक्ट जेणेकरून बदल अचानक न वाटता smooth वाटेल
//     mediaElement.style.transition = 'none';
//     mediaElement.style.opacity = '0';
//     requestAnimationFrame(() => {
//       mediaElement.style.transition = 'opacity 250ms ease';
//       mediaElement.style.opacity = '1';
//     });
//   }
//   return;
// }
//     const swiperComponent = this.querySelector('swiper-component');
//     if (!swiperComponent) return;
    
//     const waitForSwiper = (retries = 10) => {
//       if (swiperComponent.initSwiper) {
//         const slides = Array.from(swiperComponent.querySelectorAll('.swiper-wrapper .swiper-slide'));
//         let slideIndex = mediaIndex;
//         const slideElement = mediaElement.closest('.swiper-slide');
//         if (slideElement) {
//           const foundIndex = slides.indexOf(slideElement);
//           if (foundIndex >= 0) {
//             slideIndex = foundIndex;
//           }
//         }

//         if (slideIndex >= 0 && slideIndex < slides.length && swiperComponent.initSwiper) {
//           // swiperComponent.initSwiper.slideTo(slideIndex, smooth ? 800 : 0);
//           swiperComponent.initSwiper.slideTo(slideIndex, 0);
//         }
//       } else if (retries > 0) {
//         setTimeout(() => waitForSwiper(retries - 1), 50);
//       }
//     };

//     waitForSwiper();
//   } catch (e) {
//     try {
//       if (this.slideshow && typeof this.slideshow.goTo === 'function') {
//         this.slideshow.goTo(mediaIndex);
//       }
//     } catch (err) {
//       // silent
//     }
//   }
// }
//       /**
//        * Sync thumbnails controls when media is activated
//        * @param {HTMLElement} mediaElement - The active media element
//        * @param {number} mediaIndex - The index of the media in the gallery
//        */
//       syncThumbnails(mediaElement, mediaIndex) {
//         try {
//           const thumbnailsContainer = this.querySelector('.swiper-controls__thumbnails-container');
//           if (!thumbnailsContainer) return;

//           const thumbnailButtons = Array.from(thumbnailsContainer.querySelectorAll('.swiper-controls__thumbnail[data-index]'));
//           if (thumbnailButtons.length === 0) return;

//           let slideIndex = mediaIndex;
          
//           if (this.classList.contains('media-gallery--carousel')) {
//             const swiperComponent = this.querySelector('swiper-component');
//             if (swiperComponent) {
//               const slideElement = mediaElement.closest('.swiper-slide');
//               if (slideElement) {
//                 const slides = Array.from(swiperComponent.querySelectorAll('.swiper-wrapper .swiper-slide'));
//                 const foundIndex = slides.indexOf(slideElement);
//                 if (foundIndex >= 0) {
//                   slideIndex = foundIndex;
//                 }
//               } else {
//                 if (swiperComponent.initSwiper && typeof swiperComponent.initSwiper.activeIndex === 'number') {
//                   slideIndex = mediaIndex;
//                 }
//               }
//             }
//           }

//           let targetThumbnail = thumbnailButtons.find((button) => {
//             const index = parseInt(button.getAttribute('data-index'), 10);
//             return !isNaN(index) && index === slideIndex;
//           });

//           if (!targetThumbnail) {
//             targetThumbnail = thumbnailButtons.find((button) => {
//               const index = parseInt(button.getAttribute('data-index'), 10);
//               return !isNaN(index) && index === mediaIndex;
//             });
//           }

//           if (targetThumbnail) {
//             const finalSlideIndex = parseInt(targetThumbnail.getAttribute('data-index'), 10);

//             this.syncThumbnailSwiper(thumbnailsContainer, thumbnailButtons, targetThumbnail, finalSlideIndex);
//           }
//         } catch (e) {
//           // silent
//         }
//       }

//       /**
//        * Sync thumbnail swiper to show the active thumbnail
//        * @param {HTMLElement} thumbnailsContainer - The thumbnail container element
//        * @param {Array} thumbnailButtons - Array of all thumbnail buttons
//        * @param {HTMLElement} targetThumbnail - The active thumbnail button
//        * @param {number} slideIndex - The slide index to sync to
//        */
//       syncThumbnailSwiper(thumbnailsContainer, thumbnailButtons, targetThumbnail, slideIndex) {
//         try {
//           const waitForThumbnailSwiper = (retries = 10) => {
//             const swiperComponent = this.querySelector('swiper-component');
//             let thumbsSwiper = null;

//             if (swiperComponent && swiperComponent.initSwiper && swiperComponent.initSwiper.params && swiperComponent.initSwiper.params.thumbs) {
//               thumbsSwiper = swiperComponent.initSwiper.params.thumbs.swiper;
//             }

//             if (!thumbsSwiper) {
//               const thumbnailSwiper = thumbnailsContainer.querySelector('.swiper');
//               if (thumbnailSwiper && thumbnailSwiper.swiper) {
//                 thumbsSwiper = thumbnailSwiper.swiper;
//               }
//             }

//             if (thumbsSwiper) {
//               if (slideIndex >= 0 && slideIndex < thumbnailButtons.length) {
//                 thumbsSwiper.slideTo(slideIndex, 300);
//               }
//             } else if (retries > 0) {
//               setTimeout(() => waitForThumbnailSwiper(retries - 1), 50);
//             }
//           };

//           waitForThumbnailSwiper();
//         } catch (e) {
//           // silent
//         }
//       }

//       /**
//        * Swap media in grid layout: move variant image to first position
//        * @param {HTMLElement} mediaElement - The active media element
//        * @param {number} mediaIndex - The index of the media in the gallery
//        */
//       swapGridMedia() {
//         try {
//           if (typeof MainEvents !== 'undefined' && MainEvents.variantUpdate) {
//             const handleVariantUpdateOnce = (event) => {
//               try {
//                 const source = event?.detail?.data?.html;
//                 if (!source) return;

//                 const newMediaGallery = source.querySelector('media-gallery');
//                 if (!newMediaGallery) return;
//                 this.replaceWith(newMediaGallery);

//                 try {
//                   newMediaGallery.scrollIntoView({ behavior: 'smooth' });
//                 } catch (e) {
//                   // ignore scrolling errors
//                 }
//               } catch (e) {
//                 // silent
//               } finally {
//                 document.removeEventListener(MainEvents.variantUpdate, handleVariantUpdateOnce);
//               }
//             };
//             document.addEventListener(MainEvents.variantUpdate, handleVariantUpdateOnce);
//           }
          
//         } catch (e) {
//           // silent
//         }
//       }
//     }
//   );
// }

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        // Block setActiveMedia until shopper picks a variant (stops reload jump)
        this._variantMediaLocked = true;
      }

      connectedCallback() {
        if (this.classList.contains('media-gallery--mobile-smooth-scroll')) {
          this.#initMobileSmoothScroll();
        } else {
          this.#lockToFirstSlideOnLoad();
        }

        this.#armVariantMediaUnlock();
      }

      #armVariantMediaUnlock() {
        const unlock = (event) => {
          if (!(event.target instanceof Element)) return;
          if (!event.target.closest('variant-selects, sticky-atc')) return;
          this._variantMediaLocked = false;
        };
        document.addEventListener('pointerdown', unlock, true);
      }

      #getMobileScrollEl() {
        return (
          this.querySelector('.swiper.swiper-main') ||
          this.querySelector('.swiper-native-scroll') ||
          this.querySelector('.swiper-wrapper')
        );
      }

      #lockToFirstSlideOnLoad() {
        // Do not call scrollToSlide — it destroys Swiper and blanks the gallery.
        const run = () => {
          if (!this._variantMediaLocked) return;
          const swiper = this.querySelector('swiper-component')?.initSwiper;
          if (!swiper) return;
          try {
            swiper.slideTo(0, 0);
          } catch (e) {
            // silent
          }
        };

        run();
        setTimeout(run, 150);
        setTimeout(run, 500);
      }

      #isMobileSmoothScroll() {
        return this.classList.contains('media-gallery--mobile-smooth-scroll') && window.innerWidth < 750;
      }

      #initMobileSmoothScroll() {
        if (window.innerWidth >= 750) {
          this.#lockToFirstSlideOnLoad();
          return;
        }

        const prepare = () => {
          this.#destroySwiperForNativeScroll();
          const scrollEl = this.#getMobileScrollEl();
          if (scrollEl) scrollEl.scrollLeft = 0;
        };

        prepare();
        setTimeout(prepare, 150);
        setTimeout(prepare, 500);

        // If Swiper still inits later (deferUntilInteraction), kill it again
        this.#watchAndKillSwiper();
      }

      #watchAndKillSwiper() {
        if (this._swiperWatchBound || window.innerWidth >= 750) return;
        this._swiperWatchBound = true;

        const observer = new MutationObserver(() => {
          if (!this.#isMobileSmoothScroll()) return;
          const swiperEl = this.querySelector('.swiper.swiper-main');
          if (swiperEl?.swiper || this.querySelector('swiper-component')?.initSwiper) {
            this.#destroySwiperForNativeScroll();
          }
        });

        observer.observe(this, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style'],
          childList: true,
        });

        // Also poll briefly after first interaction window
        let tries = 0;
        const poll = setInterval(() => {
          tries += 1;
          if (!this.#isMobileSmoothScroll() || tries > 20) {
            clearInterval(poll);
            return;
          }
          this.#destroySwiperForNativeScroll();
        }, 250);
      }

      #destroySwiperForNativeScroll() {
        this.querySelectorAll('swiper-component').forEach((comp) => {
          if (typeof comp.prepareNativeMobileScroll === 'function') {
            comp.prepareNativeMobileScroll();
            return;
          }
          if (comp.initSwiper) {
            try {
              comp.initSwiper.destroy(true, true);
            } catch (e) {
              // silent
            }
            comp.initSwiper = null;
          }
        });

        this.querySelectorAll('.swiper').forEach((swiperEl) => {
          if (!swiperEl.swiper) return;
          try {
            swiperEl.swiper.destroy(true, true);
          } catch (e) {
            // silent
          }
          swiperEl._swiperInitialized = false;
          swiperEl.classList.add('swiper-native-scroll');
        });

        this.querySelectorAll('.swiper-wrapper, picture[data-swiper-parallax]').forEach((el) => {
          el.style.setProperty('transform', 'none', 'important');
          el.style.setProperty('transition-duration', '0ms', 'important');
        });
      }

      resetMobileTransforms() {
        this.#destroySwiperForNativeScroll();
      }

      scrollToSlide(slide, smooth = false) {
        if (!slide) return;

        this.#destroySwiperForNativeScroll();

        const scrollEl = this.#getMobileScrollEl();
        if (!scrollEl) return;

        // Prefer scrolling the .swiper viewport; fall back to wrapper offset
        let left = 0;
        if (scrollEl.classList.contains('swiper-wrapper')) {
          left = slide.offsetLeft;
        } else {
          const wrapper = scrollEl.querySelector(':scope > .swiper-wrapper') || slide.parentElement;
          left = slide.offsetLeft - (wrapper?.offsetLeft || 0);
        }

        requestAnimationFrame(() => {
          if (typeof scrollEl.scrollTo === 'function') {
            scrollEl.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
          } else {
            scrollEl.scrollLeft = left;
          }
        });
      }

      setActiveMedia(mediaId, smooth = false) {
        if (!mediaId) return false;

        // Ignore programmatic jumps to variant media on page load
        if (this._variantMediaLocked) return false;

        let cleanMediaId = String(mediaId);
        if (cleanMediaId.indexOf('-') !== -1) {
          const parts = cleanMediaId.split('-');
          cleanMediaId = parts[parts.length - 1];
        }

        let element =
          this.querySelector(`.swiper-wrapper .swiper-slide [data-media-id="${cleanMediaId}"]`) ||
          this.querySelector(`.media-gallery__grid-item [data-media-id="${cleanMediaId}"]`) ||
          this.querySelector(`[data-media-id="${cleanMediaId}"]`);

        if (!element) {
          element = this.querySelector(`[data-media-id="${mediaId}"]`);
        }

        if (!element) return false;

        this.querySelectorAll('[data-media-id].active').forEach((node) => node.classList.remove('active'));
        element.classList.add('active');

        const slideElement = element.closest('.swiper-slide');
        const slides = slideElement
          ? Array.from(this.querySelectorAll('.swiper-wrapper > .swiper-slide'))
          : [];
        const slideIndex = slideElement ? slides.indexOf(slideElement) : -1;
        const index = slideIndex >= 0 ? slideIndex : 0;

        this.syncSlideshow(element, index, smooth);
        this.syncThumbnails(element, index);

        if (this.classList.contains('media-gallery--grid')) {
          this.swapGridMedia(element, index);
        }

        return true;
      }

      syncSlideshow(mediaElement, mediaIndex, smooth = false) {
        try {
          if (!this.classList.contains('media-gallery--carousel')) return;

          if (this.#isMobileSmoothScroll()) {
            const slide = mediaElement.closest('.swiper-slide');
            if (slide) this.scrollToSlide(slide, smooth);
            return;
          }

          const swiperComponent = this.querySelector('swiper-component');
          if (!swiperComponent) return;

          const waitForSwiper = (retries = 10) => {
            if (swiperComponent.initSwiper) {
              const slides = Array.from(
                swiperComponent.querySelectorAll('.swiper-wrapper .swiper-slide')
              );
              let slideIndex = mediaIndex;
              const slideElement = mediaElement.closest('.swiper-slide');
              if (slideElement) {
                const foundIndex = slides.indexOf(slideElement);
                if (foundIndex >= 0) slideIndex = foundIndex;
              }

              if (slideIndex >= 0 && slideIndex < slides.length) {
                swiperComponent.initSwiper.slideTo(slideIndex, smooth ? 300 : 0);
              }
            } else if (retries > 0) {
              setTimeout(() => waitForSwiper(retries - 1), 50);
            }
          };

          waitForSwiper();
        } catch (e) {
          try {
            if (this.slideshow && typeof this.slideshow.goTo === 'function') {
              this.slideshow.goTo(mediaIndex);
            }
          } catch (err) {
            // silent
          }
        }
      }

      syncThumbnails(mediaElement, mediaIndex) {
        try {
          const thumbnailsContainer = this.querySelector('.swiper-controls__thumbnails-container');
          if (!thumbnailsContainer) return;

          const thumbnailButtons = Array.from(
            thumbnailsContainer.querySelectorAll('.swiper-controls__thumbnail[data-index]')
          );
          if (thumbnailButtons.length === 0) return;

          let slideIndex = mediaIndex;

          if (this.classList.contains('media-gallery--carousel')) {
            const slideElement = mediaElement.closest('.swiper-slide');
            if (slideElement) {
              const slides = Array.from(this.querySelectorAll('.swiper-wrapper > .swiper-slide'));
              const foundIndex = slides.indexOf(slideElement);
              if (foundIndex >= 0) slideIndex = foundIndex;
            }
          }

          let targetThumbnail = thumbnailButtons.find((button) => {
            return parseInt(button.getAttribute('data-index'), 10) === slideIndex;
          });

          if (!targetThumbnail) {
            targetThumbnail = thumbnailButtons.find((button) => {
              return parseInt(button.getAttribute('data-index'), 10) === mediaIndex;
            });
          }

          if (targetThumbnail) {
            const finalSlideIndex = parseInt(targetThumbnail.getAttribute('data-index'), 10);
            this.syncThumbnailSwiper(thumbnailsContainer, thumbnailButtons, targetThumbnail, finalSlideIndex);
          }
        } catch (e) {
          // silent
        }
      }

      syncThumbnailSwiper(thumbnailsContainer, thumbnailButtons, targetThumbnail, slideIndex) {
        try {
          if (this.#isMobileSmoothScroll()) return;

          const waitForThumbnailSwiper = (retries = 10) => {
            const swiperComponent = this.querySelector('swiper-component');
            let thumbsSwiper = null;

            if (swiperComponent?.initSwiper?.params?.thumbs?.swiper) {
              thumbsSwiper = swiperComponent.initSwiper.params.thumbs.swiper;
            }

            if (!thumbsSwiper) {
              const thumbnailSwiper = thumbnailsContainer.querySelector('.swiper');
              if (thumbnailSwiper?.swiper) thumbsSwiper = thumbnailSwiper.swiper;
            }

            if (thumbsSwiper) {
              if (slideIndex >= 0 && slideIndex < thumbnailButtons.length) {
                thumbsSwiper.slideTo(slideIndex, 300);
              }
            } else if (retries > 0) {
              setTimeout(() => waitForThumbnailSwiper(retries - 1), 50);
            }
          };

          waitForThumbnailSwiper();
        } catch (e) {
          // silent
        }
      }

      swapGridMedia() {
        try {
          if (typeof MainEvents === 'undefined' || !MainEvents.variantUpdate) return;

          const handleVariantUpdateOnce = (event) => {
            try {
              if (event?.detail?.data?.skipMediaUpdate) {
                document.removeEventListener(MainEvents.variantUpdate, handleVariantUpdateOnce);
                return;
              }

              const source = event?.detail?.data?.html;
              if (!source) return;

              const newMediaGallery = source.querySelector('media-gallery');
              if (!newMediaGallery) return;
              this.replaceWith(newMediaGallery);
            } catch (e) {
              // silent
            } finally {
              document.removeEventListener(MainEvents.variantUpdate, handleVariantUpdateOnce);
            }
          };

          document.addEventListener(MainEvents.variantUpdate, handleVariantUpdateOnce);
        } catch (e) {
          // silent
        }
      }
    }
  );
}
